<form id="KranSetup" [formGroup]="SetupForm" (ngSubmit)="sucheKran()">
  <fieldset id="RuestzustandBereich">
    <legend>
      <ng-container
        i18n="
          Heading parts selection|Heading for selection of configuration of
          crane@@HeadingPartSelection"
        >Parts Selection</ng-container
      >&nbsp;
      <span *ngIf="kranname !== ''">
        <ng-container i18n="Text for|Just text: for@@For">for</ng-container>
        {{ kranname }}
      </span>
    </legend>
    <!-- 		<div class="FeldMitBeschreibung"> -->
    <!-- 			<div class="Beschreibung">Chart Number:</div> -->
    <!-- 			<div class="EingabeFeld"> -->
    <!-- 				<select id="Identnr" formControlName="Identnr" -->
    <!-- 					(change)="ruestzustandAendern($event)" -->
    <!-- 					[(ngModel)]="gesetzteIdentnr"> -->
    <!-- 					<option *ngFor="let identnr of identnummern" [value]="identnr" -->
    <!-- 						[selected]="gesetzteIdentnr == identnr">{{identnr}}</option> -->
    <!-- 				</select> -->
    <!-- 			</div> -->
    <!-- 		</div> -->
    <div class="Zeile clearfix">
      <div class="FeldMitBeschreibung">
        <div class="Beschreibung">Combination:</div>
        <div class="EingabeFeld">
          <select
            id="Kombination"
            formControlName="Kombination"
            (change)="ruestzustandAendern($event)"
          >
            <option
              *ngFor="let kombination of kombinationen"
              [value]="kombination"
              [selected]="gesetzteKombination == kombination"
            >
              {{ kombination }}
            </option>
          </select>
          <div class="infobereich bstooltip">
            <!--Info Icon-->
            <div class="info-icon" id="info-icon"></div>
            <div
              class="tooltiptext below"
              style="width: 240px; text-align: left; margin-left: -120px"
            >
              <table>
                <tr>
                  <td>MB</td>
                  <td i18n="Tooltip main boom|Text for tooltip@@MainBoom">
                    main boom
                  </td>
                </tr>
                <tr>
                  <td>SA</td>
                  <td i18n="Tooltip side assist|Text for tooltip@@SideAssist">
                    side assist
                  </td>
                </tr>
                <tr>
                  <td>SA_H</td>
                  <td
                    i18n="
                      Tooltip side assist hydraulic|Text for
                      tooltip@@SideAssistHydraulic"
                  >
                    side assist (hydraulic)
                  </td>
                </tr>
                <tr>
                  <td>BE</td>
                  <td
                    i18n="
                      Tooltip boom extension|Text for tooltip@@BoomExtension"
                  >
                    boom extension
                  </td>
                </tr>
                <tr>
                  <td>BE_H</td>
                  <td
                    i18n="
                      Tooltip boom extensionhydraulic|Text for
                      tooltip@@BoomExtensionHydraulic"
                  >
                    boom extension (hydraulic)
                  </td>
                </tr>
                <tr>
                  <td>HDJ</td>
                  <td
                    i18n="Tooltip heavy duty jib|Text for tooltip@@HeavyDutyJib"
                  >
                    heavy duty jib
                  </td>
                </tr>
                <tr>
                  <td>HDJ_H</td>
                  <td
                    i18n="
                      Tooltip heavy duty jib hydraulic|Text for
                      tooltip@@HeavyDutyJibHydraulic"
                  >
                    heavy duty jib (hydraulic)
                  </td>
                </tr>
                <tr>
                  <td>LJ</td>
                  <td i18n="Tooltip luffing jib|Text for tooltip@@LuffingJib">
                    luffing jib
                  </td>
                </tr>
                <tr>
                  <td>..._MWL</td>
                  <td
                    i18n="
                      Tooltip inclusive MegaWingLift|Text for
                      tooltip@@InclusiveMegaWingLift"
                  >
                    inclusive MegaWingLift
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="FeldMitBeschreibung">
        <div class="Beschreibung">
          <ng-container
            i18n="
              Label outrigger base|Label for outrigger base@@LabelOutriggerBase"
            >Outrigger Base</ng-container
          >
          :
        </div>
        <div class="EingabeFeld">
          <!--
					<select id="AbstuetzW" formControlName="AbstuetzW"
						(change)="ruestzustandAendern($event)">
						<option *ngFor="let abstuetzung of abstuetzungen"
							[value]="abstuetzung"
							[selected]="gesetzteAbstuetzung == abstuetzung">{{abstuetzung}}</option>
					</select>
					 -->
          <input
            type="text"
            id="AbstuetzW"
            formControlName="AbstuetzW"
            [value]="gesetzteAbstuetzung"
            readonly
          />
        </div>
      </div>
    </div>
    <div class="Zeile clearfix">
      <div class="FeldMitBeschreibung">
        <div class="Beschreibung">
          <ng-container
            i18n="Label MB|Label for main boom length@@LabelMainBoomLength"
            >Main Boom Length</ng-container
          >
          :
        </div>
        <div class="EingabeFeld">
          <select
            id="HALaenge"
            formControlName="HALaenge"
            (change)="ruestzustandAendern($event)"
          >
            <option
              *ngFor="let haLaenge of haLaengen"
              [value]="haLaenge"
              [selected]="haLaenge == gesetzteHALaenge"
            >
              {{ rundeHAWerte(haLaenge, stellenNachEinheitenSystem) }}
            </option>
          </select>
          <span class="Bemassung_Dropdown">{{ laengenEinheit }}</span>
        </div>
      </div>
      <div class="FeldMitBeschreibung">
        <div class="Beschreibung">
          <ng-container
            i18n="
              Label MB Sequence|Label for main boom
              sequence@@LabelMainBoomSequence"
            >Boom Sequence</ng-container
          >
          :
        </div>
        <div class="EingabeFeld">
          <select
            id="HAAusfahrf"
            formControlName="HAAusfahrf"
            (change)="ruestzustandAendern($event)"
          >
            <option
              *ngFor="let ausfahrfolge of haAusfahrfolgen"
              [value]="ausfahrfolge"
              [selected]="gesetzteHAAusfahrf == ausfahrfolge"
            >
              {{ ausfahrfolge }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="Zeile clearfix">
      <div class="FeldMitBeschreibung">
        <div class="Beschreibung">
          <ng-container
            i18n="
              Label counterweight|Label for Counterweight@@LabelCounterweight"
            >Counterweight</ng-container
          >
          :
        </div>
        <div class="EingabeFeld">
          <select
            id="Gegengew"
            formControlName="Gegengew"
            (change)="ruestzustandAendern($event)"
          >
            <option
              *ngFor="let gegengewicht of gegengewichte"
              [value]="gegengewicht"
              [selected]="gesetztesGegengew == gegengewicht"
            >
              {{ gegengewicht }}
            </option>
          </select>
          <span class="Bemassung_Dropdown">{{ gewichtsEinheit }}</span>
        </div>
      </div>
      <div class="FeldMitBeschreibung">
        <div class="Beschreibung">
          <ng-container
            i18n="Label Slew Angle|Label for slew angle@@LabelSlewAngle"
            >Slew Angle</ng-container
          >:
        </div>
        <div class="EingabeFeld" style="width: 330px">
          <input
            type="text"
            id="OWWinkel"
            formControlName="OWWinkel"
            [value]="OWWinkel"
            (change)="aendereOWWinkel($event)"
            (keyup.enter)="aendereOWWinkel($event)"
          /><span class="Bemassung">°</span>
          <div class="FeldButton">
            <img
              [src]="grafikBasis + 'resetButton.png'"
              height="15px"
              (click)="aendereOWWinkel('')"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="Stuetzenwahl">
      <div class="Table w100">
        <div class="Row w100">
          <div class="Cell">
            <img [(src)]="stuetzeHR" (click)="aendereAbstuetzung('h', 'r')" />
          </div>
          <div class="Cell">
            <ng-container *ngIf="showOutriggerVariant('VH')">
              <input
                type="radio"
                style="margin-left: 42px"
                id="VorneHintenAbstuetzung"
                formControlName="Abstuetzverteilung"
                value="VH"
                (change)="aendereAbstuetzverteilung('VH')"
                checked
              /><label for="VorneHintenAbstuetzung"
                ><img
                  [src]="grafikBasis + 'linked.png'"
                  style="margin-left: 8px"
              /></label>
            </ng-container>
          </div>
          <div class="Cell">
            <img [src]="stuetzeHL" (click)="aendereAbstuetzung('h', 'l')" />
          </div>
        </div>
        <div class="Row w100" style="height: 200px">
          <div class="Cell">
            <ng-container *ngIf="showOutriggerVariant('LR')">
              <input
                type="radio"
                id="LinksRechtsAbstuetzung"
                formControlName="Abstuetzverteilung"
                value="LR"
                (change)="aendereAbstuetzverteilung('LR')"
              /><label for="LinksRechtsAbstuetzung"
                ><img
                  [src]="grafikBasis + 'linked_vertikal.png'"
                  style="margin-left: 8px"
              /></label>
            </ng-container>
          </div>
          <div class="Cell">
            <app-image-angle-from-center
              [grafik]="drehWinkelGrafik"
              [drehen]="90"
              [meinStyle]="{ 'max-width': '150px' }"
              [hervorhebenStyle]="'solid'"
              (owWinkelGeaendert)="aendereOWWinkel($event)"
            ></app-image-angle-from-center>
          </div>
          <div class="Cell">
            <ng-container *ngIf="showOutriggerVariant('0')">
              <input
                type="radio"
                id="NullAbstuetzung"
                formControlName="Abstuetzverteilung"
                value="0G"
                (change)="aendereAbstuetzverteilung('0G')"
              />&nbsp;<label for="NullAbstuetzung"
                ><ng-container
                  i18n="
                    Label single outrigger|Label single
                    outrigger@@LabelSingleOutrigger"
                  >One</ng-container
                >
                0%</label
              >
            </ng-container>
            <br />
            <ng-container *ngIf="showOutriggerVariant('50')">
              <input
                type="radio"
                id="50ProzentAbstuetzung"
                formControlName="Abstuetzverteilung"
                value="50G"
                (change)="aendereAbstuetzverteilung('50G')"
              />&nbsp;<label for="50ProzentAbstuetzung"
                ><ng-container
                  i18n="
                    Label single outrigger|Label single
                    outrigger@@LabelSingleOutrigger"
                  >One</ng-container
                >
                50%</label
              >
            </ng-container>
          </div>
        </div>
        <div class="Row w100">
          <div class="Cell">
            <img [src]="stuetzeVR" (click)="aendereAbstuetzung('v', 'r')" />
          </div>
          <div class="Cell"></div>
          <div class="Cell">
            <img [src]="stuetzeVL" (click)="aendereAbstuetzung('v', 'l')" />
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="bitteWarten()" class="sanduhr">
      <div class="sanduhrDisplay"></div>
    </div>
  </fieldset>
  <br />
  <fieldset id="RLHBereich">
    <legend
      i18n="
        Heading Requirements@Heading for Requirements in setup dialog for
        MAXBase@@HeadingRequirementsSetup"
    >
      Requirements
    </legend>
    <div id="RLHRadius">
      <ng-container
        i18n="Label Radius|Label for radius input in setup dialog@@Radius"
        >Radius</ng-container
      >
      :
      <input
        type="text"
        id="Radius"
        formControlName="Radius"
        (keyup.enter)="sucheKran(Abstuetzverteilung)"
      /><span class="Bemassung">{{ laengenEinheit }}</span>
    </div>
    <div id="RLHLast">
      <ng-container i18n="Label load|Label for input field load in setup@@Load"
        >Load</ng-container
      >
      :
      <input
        type="text"
        id="Last"
        formControlName="Last"
        (keyup.enter)="sucheKran(Abstuetzverteilung)"
      /><span class="Bemassung">{{ gewichtsEinheit }}</span>
    </div>
    <div id="RLHHoehe">
      <ng-container
        i18n="Label Height|Label for input field height in setup@@Height"
        >Tip Height</ng-container
      >
      :
      <input
        type="text"
        id="Hoehe"
        formControlName="Hoehe"
        (keyup.enter)="sucheKran(Abstuetzverteilung)"
      /><span class="Bemassung">{{ laengenEinheit }}</span>
    </div>
  </fieldset>
  <br />
  <fieldset id="FormularButtons">
    <div>
      <div id="formular-steuerung">
        <!-- <input type="button" name="suche" value="Search"
						(click)="sucheKran()" /> -->
        <a class="css-button" (click)="sucheKran()">
          <span class="css-button-text"
            ><ng-container
              i18n="Button Search|Label for a search button@@Search"
              >Search</ng-container
            ></span
          >
        </a>
        <!-- <input type="button" name="reset"
						value="reset" (click)="resetFilter('alles')" /> -->
        <a class="css-button" (click)="resetFilter('alles')">
          <span class="css-button-text"
            ><ng-container i18n="Button reset|Label for a reset button@@Reset"
              >Reset</ng-container
            ></span
          >
        </a>
      </div>
      <div id="ablauf-steuerung">
        <!-- <input type="button" name="Back" value="Back" i18n-value="Button Back|Label for back button in 360° setup@@Back"
						(click)="goBack()" /> -->
        <a class="css-button" (click)="goBack()">
          <span class="css-button-text"
            ><ng-container
              i18n="Button Back|Label for back button in 360° setup@@Back"
              >Back</ng-container
            ></span
          >
        </a>
        <!-- <input
          type="button"
          name="Continue"
          value="Continue"
          i18n-value="
             Continue button|Continue button in setup MAXBase@@Continue
          "
          (click)="goMaxBaseControl()"
          *ngIf="kranGewaehlt()"
        /> -->
        <a
          *ngIf="kranGewaehlt()"
          class="css-button"
          (click)="goMaxBaseControl()"
        >
          <span class="css-button-text"
            ><ng-container
              i18n="
                Button continue| Label for continue button in 360°
                setup@@Continue"
              >Continue</ng-container
            ></span
          >
        </a>
      </div>
    </div>
  </fieldset>
  <br />
</form>
<div>
  <span
    (click)="sortierInfoZeigenUmschalten()"
    style="cursor: pointer; font-weight: bold"
    ><ng-container
      i18n="Infos on sort Order|Text for sort order@@SetupSortOrder"
      >Info on sorting</ng-container
    >
    (<span
      *ngIf="!zeigeSortierInfos"
      i18n="Simple text@Text for show in setup MAXBase@@Show"
      >show</span
    ><span
      *ngIf="zeigeSortierInfos"
      i18n="Simple text|Text for hide in setup MAXbase@@Hide"
      >hide</span
    >)
  </span>
  <span *ngIf="zeigeSortierInfos">
    <br />
    <ng-container
      i18n="
        Infos on table sorting|Information regarding the sorting of a
        table@@InfoTableSorting"
      >To dynamically sort a particular column, click on its column header. The
      order switches between ascending and descending each time you click a
      column header for sorting.<br />
      You can sort more than one column by pressing “Ctrl key + mouse left
      click” on the column header.<br />
      To clear sorting for particular column, press “Shift + mouse left
      click”.</ng-container
    >
  </span>
</div>
<!-- <div *ngIf="gesetzteAbstuetzung != gesetzteAbstuetzungUngespiegelt">Please -->
<!-- 	note that if a LR base is choosen the details give for sector and slew -->
<!-- 	angle are mirrored.</div> -->
<span id="RuesttabelleBereich">
  <ej-grid
    #KranTabelle
    allowResizeToFit="true"
    [allowFiltering]="true"
    [allowMultiSorting]="true"
    [filterSettings]="filterSettings"
    [allowPaging]="true"
    [pageSettings]="tabellenEinstellungen['pageSettings']"
    [allowSorting]="true"
    [dataSource]="gridData"
    selectionType="single"
    allowSelection="true"
    [selectionSettings]="tabellenEinstellungen['selectionMode']"
    (rowSelected)="rowSelected()"
  >
    <e-columns>
      <e-column
        field="Geraet"
        i18n-headerText="
          heading model|Table heading for model in MAXbase setup@@Model"
        headerText="model"
        [visible]="false"
      ></e-column>
      <e-column
        field="Identnr"
        i18n-headerText="
          heading identnr|Table heading for identnr in MAXbase setup@@IdentNr"
        headerText="chart number"
        [visible]="false"
      ></e-column>
      <e-column
        field="Pruefnorm"
        i18n-headerText="
          heading testing standard|Table heading for testing standard in MAXbase
          setup@@TestingStandard"
        headerText="standard"
        [visible]="false"
      ></e-column>
      <e-column
        field="Kombination"
        i18n-headerText="
          heading combination|Table heading for combination in MAXbase
          setup@@Combination"
        headerText="combination"
        [visible]="true"
      ></e-column>
      <e-column
        field="HALaenge"
        i18n-headerText="
          heading boom lenght|Table heading for boom length in MAXbase
          setup@@BoomLength"
        headerText="boom length"
        format="{0:n1}"
      ></e-column>
      <e-column
        field="HAAusfahrf"
        i18n-headerText="
          heading boom sequence|Table heading for boom sequence in MAXbase
          setup@@BoomSequence"
        headerText="boom sequence"
      ></e-column>
      <e-column
        field="HILaenge"
        i18n-headerText="
          heading jib length|Table heading for jib length in MAXbase
          setup@@JibLength"
        headerText="jib length"
        [visible]="false"
      ></e-column>
      <e-column
        field="HIWinkel"
        i18n-headerText="
          heading jib angle|Table heading for jib angle in MAXbase
          setup@@JibAngle"
        headerText="jib angle"
        [visible]="false"
      ></e-column>
      <e-column
        field="Gegengew"
        i18n-headerText="
          heading counterweight|Table heading for counterweight in MAXbase
          setup@@Counterweight"
        headerText="ctwt"
      ></e-column>
      <e-column
        field="Zentralblst"
        i18n-headerText="
          heading central ballast|Table heading for central ballast in MAXbase
          setup@@CentralBallast"
        headerText="CB"
        [visible]="false"
      ></e-column>
      <e-column
        field="AbstuetzW"
        i18n-headerText="
          heading support|Table heading for support in MAXbase setup@@Support"
        headerText="support"
        [visible]="false"
      ></e-column>
      <e-column
        field="Einscher"
        i18n-headerText="
          heading number of lines heading for number of lines in MAXbase
          setup@@NumberOfLinesAbbreviated"
        headerText="no. of lines"
        [visible]="false"
      ></e-column>
      <e-column
        field="Drehber"
        i18n-headerText="
          heading slew range|Table heading for slew range in MAXbase
          setup@@SlewRange"
        headerText="slew range"
      ></e-column>
      <e-column
        field="minRadius"
        i18n-headerText="
          heading minimal radius|Table heading for minimal radius in MAXbase
          setup@@MinimalRadiusAbbreviated"
        headerText="min. radius"
      ></e-column>
      <e-column
        field="maxRadius"
        i18n-headerText="
          heading maximal radius|Table heading for maximal radius in MAXbase
          setup@@MaximalRadiusAbbreviated"
        headerText="max. radius"
      ></e-column>
      <e-column
        field="minHoehe"
        i18n-headerText="
          heading minimal tip height|Table heading for minimal tip height in
          MAXbase setup@@MinimalTipHeightAbbreviated"
        headerText="min. tip heigth"
        [visible]="false"
      ></e-column>
      <e-column
        field="maxHoehe"
        i18n-headerText="
          heading maximal tip height|Table heading for maximal tip height in
          MAXbase setup@@MaximalTipHeightAbbreviated"
        headerText="max. tip heigth"
      ></e-column>
      <e-column
        field="maxLast"
        i18n-headerText="
          heading max load|Table heading for max load in MAXbase
          setup@@MaxLoadAbbreviated"
        headerText="max. load"
      ></e-column>
      <e-column
        field="Drehrichtung"
        i18n-headerText="
          heading sector|Table heading for sector in MAXbase setup@@Sector"
        headerText="sector"
      ></e-column>
    </e-columns>
  </ej-grid>
</span>
<!--<button id="test" (click)="testWas()">Test</button>-->
<app-fehlermeldung
  [FehlerUeberschrift]="FehlerUeberschrift"
  [FehlerHinweis]="FehlerHinweis"
  [(zeigeFehlerMeldungSchalter)]="zeigeFehlerMeldung"
  [FehlerCallback]="FehlerCallback"
></app-fehlermeldung>
